import Bindings from './Bindings';
export default function ModelBindingsForName(name, binding){
		var self = this;
		var bindings = new Bindings(name, binding);
		this.containsCallbackSet=function(callbackSet){
			return getByCallbackSet(callbackSet)?true:false;
		};
		this.getByCallbackSet = getByCallbackSet;
		this.changed= function(value){
			bindings.getList().forEach((binding)=>{
				binding.callCallbackSet(value);
			});
		};
		this.add = bindings.add;
		this.getList = bindings.getList;
		this.dispose = bindings.dispose;
		this.addEventListener = bindings.addEventListener;
		this.removeEventListener = bindings.removeEventListener;
		function getByCallbackSet(callbackSet){
			const listBindings = bindings.getList();
			for(var i=0, binding; binding=listBindings[i]; i++){
				if(binding.getCallbackSet()==callbackSet){
					return binding;
				}
			}
		}
	}